import { Section } from "../models/sectionModel";
import { ADD_SECTION, ADD_SECTION_LIST, DROP_SECTION, EDIT_SECTION, MOVE_SECTION, REMOVE_ALL_SECTIONS, REMOVE_SECTION, REMOVE_SECTION_LIST, REMOVE_SECTION_LIST_BY_FORM_ID, SectionActionTypes, SET_SECTION } from "../types/actions";
import { produce } from 'immer'

const sectionReducerDefaultState: Section[] = [];

const sectionReducer = (state: Section[] = sectionReducerDefaultState, action: SectionActionTypes): Section[] => {
    switch (action.type) {
        case ADD_SECTION:
            return produce(state, draft => { draft.push(action.section) });
        case ADD_SECTION_LIST:
            return produce(state, draft => { for (let index = 0; index < action.sections.length; index++) {
                draft.push(action.sections[index]);
            } });
        case EDIT_SECTION:
            return produce(state, draft => { draft[draft.findIndex(section => section.id === action.section.id)] = action.section; });
        case REMOVE_SECTION:
            return produce(state, draft => { draft.splice(draft.findIndex(section => section.id === action.id), 1); });
        case REMOVE_SECTION_LIST_BY_FORM_ID:
                return produce(state, draft => { return draft.filter(section => section.formId !== action.formId) });
        case REMOVE_SECTION_LIST:
            return produce(state, draft => {
                for (let index = 0; index < action.sections.length; index++) {
                    draft.splice(draft.findIndex(section => section.id === action.sections[index].id), 1);
                }
            });
        case SET_SECTION:
            return action.sections;
        case DROP_SECTION:
            return produce(state, draft => {
                const index = draft.findIndex(section => section.id === action.section.id);
                if (index !== -1) draft[index].rowId = action.newRowId;
            });
        case MOVE_SECTION:
            let dragIndex = state.indexOf(action.sectionDrag);
            let hoverIndex = state.indexOf(action.sectionDrop);
            return produce(state, draft => { draft.splice(dragIndex, 1); draft.splice(hoverIndex, 0, action.sectionDrag); })
        case REMOVE_ALL_SECTIONS:
            return produce(state, draft => {return draft = []});
        default:
            return state;
    }
}

export default sectionReducer
